import { Route } from "@angular/router";
import { subscriptionWizardRegistrationRoutes } from "./features/registration/subscription-wizard-registration.routing";

export const appSubscriptionWizardRoutes: Route[] = [
  {
    path: '',
    loadChildren: () => subscriptionWizardRegistrationRoutes,
  },
]